import { CSSProperties } from 'react';
import { useIntl } from 'react-intl';
import AgLoadingCard from '../../stories/AgLoadingCard';

const Loading = ({ height, showLogo }:{ height?: CSSProperties['height']; showLogo?: boolean }) => {
  const messages = useIntl().formatMessage;

  return (
    <AgLoadingCard style={{ height }} text={messages({ id: 'LOADING' })} showLogo={showLogo} />
  );
};

export default Loading;